import React from 'react';
import { TranslationsByIdByNamespace } from '@spa/lib/i18n/common/TranslationsByIdByNamespace';

export interface IntlContextValue {
  readonly translationsByIdByNamespace: TranslationsByIdByNamespace;
  readonly enableWarnings: boolean;
}

export const IntlContext = React.createContext<IntlContextValue | null>(null);
